"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderLevel = exports.ButtonBackgroundColor = void 0;
const tslib_1 = require("tslib");
const ARIARole_1 = tslib_1.__importDefault(require("./ARIARole"));
class WCAG {
    /**
     * HTMLElement's that aren't ButtonElements do not automatically work with SPACE or Enter on click,
     * and screen readers do not know that they are buttons so we need to add aria-labels
     * @param buttonEventArgs args to addButtonEvent, overrides available.
     */
    static addButtonEvent(buttonEventArgs) {
        const { element, callback, ariaRole = ARIARole_1.default.BUTTON, buttonBackgroundColor = ButtonBackgroundColor.DEFAULT, tabIndex = "0", useCapture = false } = buttonEventArgs;
        element.setAttribute("role", ariaRole);
        element.setAttribute("tabindex", tabIndex);
        element.classList.add(buttonBackgroundColor);
        element.addEventListener("click", event => {
            if (element.hasAttribute("disabled")) {
                return;
            }
            callback(event);
        }, useCapture);
        element.addEventListener("keydown", event => {
            // Prevent spacebar from scrolling
            if ([WCAG.SPACE_KEY, WCAG.SPACE_KEY_IE].includes(event.key)) {
                event.preventDefault();
            }
        }, useCapture);
        element.addEventListener("keyup", event => {
            if (element.hasAttribute("disabled")) {
                return;
            }
            if ([WCAG.ENTER_KEY, WCAG.SPACE_KEY, WCAG.SPACE_KEY_IE].includes(event.key)) {
                callback(event);
            }
        }, useCapture);
    }
    static createSROnlyHeader(args) {
        const { headerLevel, textContent } = args;
        const srOnlyHeader = document.createElement(headerLevel);
        srOnlyHeader.classList.add("sr-only");
        srOnlyHeader.textContent = textContent;
        return srOnlyHeader;
    }
}
WCAG.ENTER_KEY = "Enter";
WCAG.SPACE_KEY = " ";
WCAG.SPACE_KEY_IE = "Spacebar";
var ButtonBackgroundColor;
(function (ButtonBackgroundColor) {
    ButtonBackgroundColor["DEFAULT"] = "default-background-color";
    ButtonBackgroundColor["NO_BG"] = "no-background-color";
    ButtonBackgroundColor["PRIMARY"] = "primary-background-color";
    ButtonBackgroundColor["WARNING"] = "warning-background-color";
    ButtonBackgroundColor["ERROR"] = "error-background-color";
    ButtonBackgroundColor["GREY"] = "grey-background-color";
    ButtonBackgroundColor["DARK_GREY"] = "dark-grey-background-color";
})(ButtonBackgroundColor = exports.ButtonBackgroundColor || (exports.ButtonBackgroundColor = {}));
var HeaderLevel;
(function (HeaderLevel) {
    HeaderLevel["H1"] = "h1";
    HeaderLevel["H2"] = "h2";
    HeaderLevel["H3"] = "h3";
    HeaderLevel["H4"] = "h4";
    HeaderLevel["H5"] = "h5";
    HeaderLevel["H6"] = "h6";
})(HeaderLevel = exports.HeaderLevel || (exports.HeaderLevel = {}));
exports.default = WCAG;
//# sourceMappingURL=WCAG.js.map